import { SITE_COPY } from "./copy";

export const ROUTES = [
  { path: "/about", label: SITE_COPY.nav.about },
  { path: "/experience", label: SITE_COPY.nav.experience },
  { path: "/work", label: SITE_COPY.nav.work },
  { path: "/writing", label: SITE_COPY.nav.writing },
  { path: "/contact", label: SITE_COPY.nav.contact },
];
